// 我的考试
<template>
  <div class="link-views white-bg">
    <div class="table-div">
      <!-- 表格 -->
      <Table :columns="columns" :data="listObj.Result" :loading="loading">
        <template slot-scope="{row}" slot="StartDate">
          <span>{{row.StartDate}}</span>&nbsp;&nbsp;
          <span>{{row.EndDate}}</span>
        </template>
        <template slot-scope="{ row}" slot="action">
          <div class="action-table" v-if="row.IsType">
            <a @click="showTxam(row)">查看试卷</a>
          </div>
          <div v-else>
            <a v-if="row.isTakeExam==1" class="ok" @click="getTxam(row)">开始考试</a>
            <a v-else-if="row.isTakeExam==2" class="red">暂未开始</a>
            <a v-else-if="row.isTakeExam==3" class="gray">已结束</a>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          show-total
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
    <!-- 模态框 -->
    <Modal
      v-model="showfullscreen"
      fullscreen
      :title="TestName"
      :class="{'myfullscreen':true,'noLeft':isCollapsed }"
      :mask-closable="false"
    >
      <div v-if="TestQueList.length>0" class="TestQueListBox">
        <div class="text-right error" style="font-size:20px;">
          <count-down
            v-on:end_callback="countDownE_cb(1)"
            :startTime="startTime"
            :endTime="endTime"
            :dayTxt="'天'"
            :hourTxt="'小时'"
            :minutesTxt="'分钟'"
            :secondsTxt="'秒'"
          ></count-down>
          <div v-if="showEndText">00小时00分钟00秒</div>
        </div>
        <div v-for="(item,index) in TestQueList" :key="index" class="TestQueList">
          <div class="title">{{index+1}}、{{item.QuestionsName}}?</div>
          <div class="TestImgVideo">
            <video class="videoCursor"
              v-if="item.QuestionsType=='S'"
              :src="port+item.VideoUrl"
              @click="changeActiveVideoUrl(item.VideoUrl)"
            >您的浏览器不支持 video 标签。</video>
            <img v-else-if="item.QuestionsType=='T'" :src="port+item.ImgUrl" alt>
          </div>

          <div v-if="item.Type=='M'">
            <checkbox-group v-model="item.StuAnswer">
              <div class="groupItem">
                <checkbox label="A" v-if="item.OptionA">
                  <span>A、{{item.OptionA}}</span>
                </checkbox>
              </div>
              <div class="groupItem">
                <checkbox label="B" v-if="item.OptionB">
                  <span>B、{{item.OptionB}}</span>
                </checkbox>
              </div>
              <div class="groupItem">
                <checkbox label="C" v-if="item.OptionC">
                  <span>C、{{item.OptionC}}</span>
                </checkbox>
              </div>
              <div class="groupItem">
                <checkbox label="D" v-if="item.OptionD">
                  <span>D、{{item.OptionD}}</span>
                </checkbox>
              </div>
            </checkbox-group>
          </div>
          <div v-else>
            <radio-group v-model="item.StuAnswer">
              <div class="groupItem">
                <radio label="A" v-if="item.OptionA">
                  <icon type="social-apple"></icon>
                  <span>A、{{item.OptionA}}</span>
                </radio>
              </div>
              <div class="groupItem">
                <radio label="B" v-if="item.OptionB">
                  <span>B、{{item.OptionB}}</span>
                </radio>
              </div>
              <div class="groupItem">
                <radio label="C" v-if="item.OptionC">
                  <span>C、{{item.OptionC}}</span>
                </radio>
              </div>
              <div class="groupItem">
                <radio label="D" v-if="item.OptionD">
                  <span>D、{{item.OptionD}}</span>
                </radio>
              </div>
            </radio-group>
          </div>
        </div>
      </div>
      <div v-else class="nodata">暂无试题</div>
      <div slot="footer">
        <Button type="text" @click="showfullscreen=false">取消</Button>
        <Button type="primary" @click="sureEdit">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="showFullInfo"
      fullscreen
      :title="TestName"
      :class="{'myfullscreen':true,'nofooter':true,'noLeft':isCollapsed }"
    >
      <div v-if="showQueList.length>0" class="TestQueListBox">
        <div class="title">
          <span class="mr">本次考试分数为</span>
          <strong class="error">{{Score}}</strong>
        </div>

        <div v-for="(item,index) in showQueList" :key="index" class="TestQueList">
          <div class="title">{{index+1}}、{{item.QuestionsName}}?</div>
          <div class="TestImgVideo">

             <video class="videoCursor"
              v-if="item.QuestionsType=='S'"
              :src="port+item.VideoUrl"
              @click="changeActiveVideoUrl(item.VideoUrl)"
            >您的浏览器不支持 video 标签。</video>
            <img v-else-if="item.QuestionsType=='T'" :src="port+item.ImgUrl" alt>
          </div>
          <ul class="groupItem">
            <li v-if="item.OptionA">A、{{item.OptionA}}</li>
            <li v-if="item.OptionB">B、{{item.OptionB}}</li>
            <li v-if="item.OptionC">C、{{item.OptionC}}</li>
            <li v-if="item.OptionD">D、{{item.OptionD}}</li>
          </ul>
          <div>
            我的答案：
            <span :class="item.IsRight?'theme':'error'">{{item.StuAnswer}}</span>
          </div>
          <div>
            正确答案：
            <span class="theme">{{item.RightAnswer}}</span>
          </div>
        </div>
      </div>
      <div v-else class="nodata">暂无试题</div>
    </Modal>

      <!-- 视频播放模态框 -->
    <Modal v-model="showModalVideoUrl" :mask-closable="false" title="视频" :closable="false">
      <video  id="vide" v-if="activeVideoUrl" :src="port+activeVideoUrl" style="width:100%" controls></video>
      <div slot="footer">
         <Button  type="text" @click="changeVideoUrl">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/student-api.js";
import * as allFn from "../../../utils/index.js";
import CountDown from "vue2-countdown";
export default {
  name: "myTest",

  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true,
      pageData: {
        page: 1,
        size: 10
      },
      listObj: {},
      columns: [
        //设置表格参数
        { title: "开考时间", slot: "StartDate", align: "center" },
        { title: "开考内容", key: "TestPaperName", align: "center" },
        { title: "考试班级", key: "ClassName", align: "center" },
        { title: "考试要求", key: "TestRequire", align: "center" },
        { title: "可选操作", slot: "action", align: "center" }
      ],
      showfullscreen: false,
      TestName: "",
      TestQueList: [],
      submitObj: {},
      showFullInfo: false,
      showQueList: [],
      Score: 0,
      startTime: null,
      endTime: null,
      showEndText: false,
       showModalVideoUrl: false,
      activeVideoUrl: ""
    };
  },
  components: {
    CountDown
  },
  mounted() {
    this.getpageArr();
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  methods: {
    countDownE_cb: function(x) {
      this.showEndText = true;
      this.$Modal.confirm({
        content: "考试时间已结束",
        onOk: () => {
          this.sureEdit();
        },
        onCancel: () => {
          this.sureEdit();
        }
      });
    },
    // 获取分页数据
    getpageArr() {
      homeApi
        .GetMyTestList({
          page: this.pageData.page ? this.pageData.page : 1,
          size: this.pageData.size ? this.pageData.size : 10
        })
        .then(res => {
          var arr = res.Result;
          for (let index = 0; index < arr.length; index++) {
            arr[index].isTakeExam = allFn.validateTime(
              arr[index].StartDate,
              arr[index].EndDate
            );
          }
          this.listObj = res;
          this.loading = false;
        });
    },
    //分页
    changePage(page) {
      this.pageData.page = page;
      this.getpageArr();
    },
    // 获取考试
    getTxam(row) {
      this.startTime = new Date().getTime();
      this.endTime = new Date(
        row.StartDate + " " + row.EndDate.split("-")[1]
      ).getTime();
      this.submitObj = {
        TestPaperId: row.TestPaperId,
        Score: row.Score,
        CourseId: row.CourseId,
        Questions: []
      };
      homeApi.GetMyTestQueList({ TestPaperId: row.TestPaperId }).then(res => {
        this.showfullscreen = true;
        this.TestName = row.TestPaperName;
        this.TestQueList = res;
      });
    },
    // 确定提交试卷
    sureEdit() {
      var submitData = this.TestQueList.map(item => {
        if (item.StuAnswer) {
          if (item.Type == "M") {
            return {
              QuestionsId: item.QuestionsId,
              StuAnswer: item.StuAnswer.join("")
            };
          } else {
            return { QuestionsId: item.QuestionsId, StuAnswer: item.StuAnswer };
          }
        } else {
          return { QuestionsId: item.QuestionsId, StuAnswer: "" };
        }
      });

      this.submitObj.Questions = submitData;
      homeApi.AddAnswerTest(this.submitObj).then(res => {
        if (res.success) {
          this.showfullscreen = false;
          this.getpageArr();
          this.$Message.success({
            content: res.msg,
            duration: 3
          });
        } else {
          this.$Message.error({
            content: res.msg,
            duration: 3
          });
        }
      });
    },
    // 查看试卷详情
    showTxam(row) {
      homeApi.GetTestQueList({ TestPaperId: row.TestPaperId }).then(res => {
        this.showFullInfo = true;
        this.TestName = row.TestPaperName;
        this.showQueList = res.QuestionsList;
        this.Score = res.Score;
      });
    },
      // 显示视频播放模态框
    changeActiveVideoUrl(url) {
      this.activeVideoUrl = url;
      this.showModalVideoUrl = true;
    },
     // 关闭弹框
    changeVideoUrl() {
      var vide = document.getElementById("vide");
      vide.pause();
      this.showModalVideoUrl = false;
    }
  }
};
</script>

<style scoped>
</style>